import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import * as fromGenerated from '../../../_generated';
import { sentryCaptureError } from '../../../sentry.helper';
import { TeammatesActions } from './teammates.actions';

@Injectable()
export class TeammatesEffects {
  private readonly actions$ = inject(Actions);
  private readonly teammatesService = inject(fromGenerated.TeammatesService);

  loadTeammates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeammatesActions.loadTeammates),
      switchMap(({ locale }) =>
        this.teammatesService.teammatesControllerGetTeammatesV1(locale).pipe(
          map((teammates) =>
            TeammatesActions.loadTeammatesSuccess({
              teammates,
              loadedAt: Date.now(),
            }),
          ),
          sentryCaptureError,
          catchError((error: Error) =>
            of(TeammatesActions.loadTeammatesFailure({ error: error.message })),
          ),
        ),
      ),
    ),
  );
}
